import * as React from 'react';
import { useRef } from 'react';
import { offset, position } from './type';

export default function ({path, onDrag, onWheel}: {
    path: string,
    onDrag: (offset: offset) => void,
    onWheel?: (e: WheelEvent) => void,
}) {
    const pos = useRef<position | null>(null);

    return (
    <img
        src={path}
        onWheel={e => {
            if (onWheel) {
                onWheel(e.nativeEvent)
            }
        }}
        onMouseDown={e => pos.current = { x: e.screenX, y: e.screenY }}
        onMouseUp={e => pos.current = null}
        onMouseMove={e => {
            if (pos.current !== null) {
                const [x, y] = [e.screenX, e.screenY];
                onDrag({
                    x: (x - pos.current.x),
                    y: (y - pos.current.y),
                });
                pos.current = {
                    x: e.screenX,
                    y: e.screenY,
                };
            }
        }}
        draggable={false}
    />);
}
